import { css } from "@emotion/react"
import { useEffect } from "react"
import KycPageSignals from "@/features_signal/kyc/kycPageSignals"

export default function StepKycOcr() {
    const ocrParams = KycPageSignals.ocrSetupParams.value

    useEffect(() => {
        window.addEventListener("message", (event) => {
            console.log(event)
        })
    }, [])

    return (
        <div
            css={css`
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: stretch;
                justify-content: flex-start;
            `}
        >
            <iframe
                css={css`
                    flex: 1;
                `}
                src={ocrParams.redirect_url}
            />
        </div>
    )
}
